import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner, FaCheck, FaTimes, FaEye, FaCheckCircle, FaTimesCircle, FaArrowLeft } from 'react-icons/fa'
import { useParams, useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import '../../HR Manager/screens/EmployeeGoals.css'
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../../../config/api'

const COOEmployeeGoals = () => {
  const baseUrl = API_BASE_URL
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation();
  const employeeId = location.state?.employeeId || id; // fallback to URL param
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(false)
  const [fetchingEmployee, setFetchingEmployee] = useState(true)
  const [goals, setGoals] = useState([])
  const [employee, setEmployee] = useState(null)
  const [expandedTexts, setExpandedTexts] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedGoal, setSelectedGoal] = useState(null)
  const [approvalLoading, setApprovalLoading] = useState(null); // goal id or null
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectGoal, setRejectGoal] = useState(null);
  const [rejectSubmitting, setRejectSubmitting] = useState(false);
  const [rejectError, setRejectError] = useState(null);

  const handleViewGoal = (goal) => {
    setSelectedGoal(goal)
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
    setSelectedGoal(null)
  }

  const toggleTextExpansion = (goalId, field) => {
    setExpandedTexts(prev => ({
      ...prev,
      [`${goalId}-${field}`]: !prev[`${goalId}-${field}`]
    }))
  }

  const renderTruncatedText = (text, goalId, field, maxLength = 55) => {
    const safeText = (text ?? '').toString();
    if (!safeText) return '';
    if (safeText.length <= maxLength) return safeText;

    const key = `${goalId || 'unknown'}-${field}`;
    const isExpanded = !!expandedTexts[key];
    const shownText = isExpanded ? safeText : `${safeText.slice(0, maxLength)}...`;

    return (
      <span style={{ display: 'inline' }}>
        <span style={{ whiteSpace: 'pre-wrap' }}>{shownText}</span>
        <button
          type="button"
          onClick={() => toggleTextExpansion(goalId || 'unknown', field)}
          style={{
            marginLeft: 8,
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            color: '#2563eb',
            fontWeight: 600,
            fontSize: 12,
            textDecoration: 'underline',
          }}
        >
          {isExpanded ? 'Read less' : 'Read more'}
        </button>
      </span>
    );
  }

  const handleApproveGoal = async (goal) => {
    setApprovalLoading(goal.id);
    try {
      const token = Cookies.get('token');
      await axios.post(`${baseUrl}/api/goals/${goal.id}/approval/`, { action: 'approve' }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      toast.success('Goal approved!');
      // Refresh goals
      const response = await axios.get(`${baseUrl}/api/employees/${employeeId}/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const emp = response.data.employee;
      setEmployee(emp);
      setGoals(emp.goals || []);
    } catch (err) {
        console.log(err)
      toast.error(err.message || 'Failed to approve goal');
    } finally {
      setApprovalLoading(null);
    }
  };
  const openRejectModal = (goal) => {
    setRejectGoal(goal);
    setRejectReason('');
    setRejectError(null);
    setRejectModalOpen(true);
  };
  const closeRejectModal = () => {
    setRejectModalOpen(false);
    setRejectGoal(null);
    setRejectReason('');
    setRejectError(null);
  };
  const handleRejectSubmit = async (e) => {
    e.preventDefault();
    setRejectSubmitting(true);
    setRejectError(null);
    try {
      const token = Cookies.get('token');
      await axios.post(`${baseUrl}/api/goals/${rejectGoal.id}/approval/`, { action: 'reject', reason: rejectReason }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      toast.success('Goal rejected!');
      // Refresh goals
      const response = await axios.get(`${baseUrl}/api/employees/${employeeId}/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const emp = response.data.employee;
      setEmployee(emp);
      setGoals(emp.goals || []);
      closeRejectModal();
    } catch (err) {

      setRejectError(err.message || 'Failed to reject goal');
    } finally {
      setRejectSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchEmployee = async () => {
      setFetchingEmployee(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/employees/${employeeId}/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        console.log(response.data.employee)
        const emp = response.data.employee
        setEmployee(emp)
        setGoals(emp.goals || [])
      } catch (err) {
        toast.error('Failed to fetch employee data.')
      } finally {
        setFetchingEmployee(false)
      }
    }
    if (employeeId) fetchEmployee()
  }, [employeeId])

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="employee-goals-container">
        <div className="page-header">
          <div className="header-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
            <div className="page-title" style={{ display: 'flex', alignItems: 'center', gap: 100 }}>
              <h1 style={{ margin: 0 }}>Key Performance Indicators</h1>
              {employee && (
                <span style={{ fontSize: 22, fontWeight: 600, color: '#fffb', display: 'flex', alignItems: 'center', gap: 8 }}>
                  {employee.first_name} {employee.last_name}
                </span>
              )}
            </div>
            <button
              style={{
                background: '#4F46E5',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                padding: '6px 18px',
                fontWeight: 600,
                fontSize: 15,
                cursor: 'pointer',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                transition: 'background 0.2s',
              }}
              onClick={() => navigate('/coo/employees')}
            >
              <FaArrowLeft/> &nbsp;&nbsp;Back
            </button>
          </div>
        </div>
        <div className="hr-content-wrapper">
          {fetchingEmployee ? (
            <div className="loading-state"><FaSpinner className="spinner" /> Loading employee data...</div>
          ) : employee ? (
            <>
              <div className="goals-table-wrapper">
                <table className="goals-table">
                  <thead>
                    <tr>
                      <th>Activity</th>
                      <th>Stakeholder</th>
                      <th>KPI Metric</th>
                      <th>RAG</th>
                      <th>Quarter</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {goals.length === 0 ? (
                      <tr>
                        <td colSpan={7} className="empty-row">No goals found for this employee.</td>
                      </tr>
                    ) : (
                      (() => {
                        // Group KPIs by KRA, similar to other KPI screens
                        const groupedByKra = goals.reduce((acc, goal) => {
                          const kraName =
                            (goal.key_result_area && typeof goal.key_result_area === 'object'
                              ? goal.key_result_area.name
                              : goal.key_result_area || goal.name) || 'Uncategorized';
                          if (!acc[kraName]) acc[kraName] = [];
                          acc[kraName].push(goal);
                          return acc;
                        }, {});

                        return Object.entries(groupedByKra).map(([kraName, kraGoals]) => (
                          <React.Fragment key={kraName}>
                            <tr className="kra-group-row">
                              <td colSpan={7} style={{ fontWeight: 700, background: '#f1f5f9' }}>
                                {(() => {
                                  const kraPercentage =
                                    kraGoals?.[0]?.key_result_area?.percentage ??
                                    kraGoals?.[0]?.kra?.percentage ??
                                    kraGoals?.[0]?.percentage;
                                  return (
                                    <>
                                      {kraName}
                                      {' '}
                                      <span style={{ fontWeight: 800, color: '#475569' }}>
                                        (KRA Weight: {kraPercentage !== undefined && kraPercentage !== null ? `${kraPercentage}%` : '-'})
                                      </span>
                                    </>
                                  );
                                })()}
                              </td>
                            </tr>
                            {kraGoals.map((goal, idx) => (
                              <tr key={goal.id || `${kraName}-${idx}`}>
                                <td>
                                  {renderTruncatedText(goal.activity, goal.id || `${kraName}-${idx}`, 'activity')}
                                </td>
                                <td>
                                  {renderTruncatedText(
                                    goal.stakeholder,
                                    goal.id || `${kraName}-${idx}`,
                                    'stakeholder',
                                    35
                                  )}
                                </td>
                                <td>{goal.metric}%</td>
                                <td>
                                  <div className="rag-bar-bg">
                                    <div
                                      className="rag-bar-fill"
                                      style={{ backgroundColor: goal.progress_indicator || '#e5e7eb', width: '100%' }}
                                    >
                                      <span className="rag-bar-label">{goal.rag_color || ''}</span>
                                    </div>
                                  </div>
                                </td>
                                <td>{goal.quarter}</td>
                                <td>
                                  <span className={`status-badge status-${goal.approval_status?.toLowerCase() || 'unknown'}`}>
                                    {goal.approval_status === 'pending' && <FaSpinner className="pending-spinner" />}
                                    {goal.approval_status ? goal.approval_status.charAt(0).toUpperCase() + goal.approval_status.slice(1) : ''}
                                  </span>
                                </td>
                                <td>
                                  <div className="goal-actions">
                                    <button className="action-button view-button" title="View" onClick={() => handleViewGoal(goal)}>
                                      <FaEye />
                                    </button>
                                    {goal.approval_status === 'pending' && (
                                      <>
                                        <button className="action-button approve-button" title="Approve" onClick={() => handleApproveGoal(goal)} disabled={approvalLoading === goal.id}>
                                          {approvalLoading === goal.id ? <FaSpinner className="pending-spinner" /> : <FaCheckCircle style={{ color: '#22c55e' }} />}
                                        </button>
                                        <button className="action-button reject-button" title="Reject" onClick={() => openRejectModal(goal)}>
                                          <FaTimesCircle style={{ color: '#ef4444' }} />
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ));
                      })()
                    )}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="error-state">Employee not found.</div>
          )}
        </div>
      </div>

      {modalOpen && selectedGoal && (
        <div className="modal-overlay">
          <div className="modal-content-employee-goal">
            <div className="modal-header">
              <h2>KPI Details</h2>
              <button onClick={closeModal} className="modal-close-btn">&times;</button>
            </div>
            <div className="modal-body">
              <div className="goal-details-grid">
                <div className="goal-detail-row">
                  <label>Key Result Area:</label>
                  <span>{selectedGoal.key_result_area?.name || selectedGoal.name}</span>
                </div>
                <div className="goal-detail-row">
                  <label>Key Result Area Weight:</label>
                  <span>{selectedGoal.key_result_area?.percentage || selectedGoal.percentage}%</span>
                </div>
                <div className="goal-detail-row">
                  <label>Activity:</label>
                  <span>{selectedGoal.activity}</span>
                </div>
                <div className="goal-detail-row">
                  <label>KPI Metric:</label>
                  <span>{selectedGoal.metric}%</span>
                </div>
                <div className="goal-detail-row">
                  <label>Stakeholder:</label>
                  <span>{selectedGoal.stakeholder}</span>
                </div>
                
                <div className="goal-detail-row">
                  <label>Quarter:</label>
                  <span>{selectedGoal.quarter}</span>
                </div>
                <div className="goal-detail-row">
                  <label>RAG Color:</label>
                  <div className="progress-indicator-display" style={{ backgroundColor: selectedGoal.progress_indicator || '#e5e7eb', width: '100%' }}>
                    
                  </div>
                </div>
                <div className="goal-detail-row">
                  <label>Completion Status:</label>
                  <span>
                    {selectedGoal.status 
                      ? selectedGoal.status.charAt(0).toUpperCase() + selectedGoal.status.slice(1).replace(/_/g, ' ')
                      : 'N/A'}
                  </span>
                </div>
                <div className="goal-detail-row">
                  <label>Is Overdue:</label>
                  <span className={selectedGoal.is_overdue ? 'overdue-yes' : 'overdue-no'}>
                    {selectedGoal.is_overdue ? 'Yes' : 'No'}
                  </span>
                </div>
                <div className="goal-detail-row">
                  <label>Approval Status:</label>
                  <span style={{color: '#ffc'}} className={`status-badge status-${selectedGoal.approval_status?.toLowerCase() || 'unknown'}`}>
                    {selectedGoal.approval_status === 'pending' && <FaSpinner className="pending-spinner" />}
                    {selectedGoal.approval_status ? selectedGoal.approval_status.charAt(0).toUpperCase() + selectedGoal.approval_status.slice(1) : 'N/A'}
                  </span>
                </div>
                <div className="goal-detail-row">
                  <label>Due Date:</label>
                  <span>
                    {selectedGoal.completion_date 
                      ? new Date(selectedGoal.completion_date).toLocaleDateString('en-GB')
                      : 'N/A'}
                  </span>
                </div>
                {selectedGoal.approval_status === 'rejected' && selectedGoal.rejected_reason && (
                  <div className="goal-detail-row full-width">
                    <label>Rejection Reason:</label>
                    <span className="rejection-reason">{selectedGoal.rejected_reason}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={closeModal} className="modal-close-button">Close</button>
            </div>
          </div>
        </div>
      )}

      {rejectModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content-employee-goal" style={{ maxWidth: 480 }}>
            <div className="modal-header">
              <h2>Reject Goal</h2>
              <button onClick={closeRejectModal} className="modal-close-btn">&times;</button>
            </div>
            <form onSubmit={handleRejectSubmit} className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div className="goal-detail-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
                <label style={{ fontWeight: 600, color: '#374151', marginBottom: 2 }}>Rejection Reason <span className="required">*</span></label>
                <textarea
                  name="rejection_reason"
                  value={rejectReason}
                  onChange={e => setRejectReason(e.target.value)}
                  required
                  className="form-input"
                  placeholder="Enter reason for rejection..."
                  rows={4}
                  disabled={rejectSubmitting}
                  style={{ borderRadius: 8, border: '2px solid #e5e7eb', fontSize: 16, padding: '12px 16px', minWidth: '90%' }}
                />
              </div>
              {rejectError && <div className="error-state">{rejectError}</div>}
              <div className="modal-actions">
                <button
                  type="submit"
                  className="submit-button"
                  style={{ width: '100%', fontWeight: 500, fontSize: 15, borderRadius: 8, padding: '10px 0', marginTop: 8, background: 'linear-gradient(135deg,#ef4444 0%, #f87171 100%)', color: '#fff' }}
                  disabled={rejectSubmitting}
                >
                  {rejectSubmitting ? 'Rejecting...' : 'Reject Goal'}
                </button>

                <button
                  type="button"
                  onClick={closeRejectModal}
                  className="submit-button"
                  style={{ width: '100%', fontWeight: 500, fontSize: 15, borderRadius: 8, padding: '10px 0', marginTop: 8, background: 'navy', color: '#fff' }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}

export default COOEmployeeGoals
